import { type PropsWithChildren } from "react";

export const Footer = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex h-20 w-full shrink-0 items-center gap-4 border-t border-divider-main bg-background-secondary px-3">
      {children}
    </div>
  );
};
